<template>
  <div class="element-input element-car-radio">
    <div class="label">{{ label }}</div>
    <ul>
      <li :class="{ on: value == item.value }" v-for="item in items" @click="selectItem( item.value )"><p>{{ item.label }}</p>{{ item.description }}</li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    }
  }
}
</script>
